// default query stale time = 10 seconds
export const DEFAULT_WAGMI_QUERY_STALE_TIME = 10_000;

// default query cache time = 30 seconds
export const DEFAULT_WAGMI_QUERY_CACHE_TIME = 30_000;

// 1 hour for ERC20 info since it's not expected to change
export const DEFAULT_WAGMI_QUERY_ERC20_INFO_STALE_TIME = 3_600_000;

// 1 min for reading attestations
export const DEFAULT_WAGMI_QUERY_ATTESTATION_STALE_TIME = 60_000;

// 20 seconds for gas price
export const DEFAULT_WAGMI_QUERY_GAS_PRICE_STALE_TIME = 20_000;

// 1 minute for asset price
export const DEFAULT_WAGMI_QUERY_ASSET_PRICE_STALE_TIME = 60_000;

// 15 seconds for position data - short enough to notice changes, long enough for smooth pagination
export const DEFAULT_POSITIONS_STALE_TIME = 20_000;
